import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show nothing while checking authentication status
  if (isLoading) {
    return <div className="loading-container">Loading...</div>;
  }

  // Redirect to Settings page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/settings" replace state={{ showSignInToast: true }} />;
  }

  return children;
};

export default ProtectedRoute;
